<template>
  <section id="my-page-header">
    <div id="my-page-image-wrapper">
      <img id="my-page-icon" src="@/assets/icon-mypage-2.png" alt="">
      <h1>マイページ</h1>
    </div>
    <div id="my-page-navigation-wrapper">
      <button
        @click="updateHeading('top')"
        :class="{'js-nav__active': this.heading === 'top'}"
        class="p-mypageHeding--nav__top js-top"
      >
        <img class="button-icon" src="@/assets/icon-mypage-top.png" alt="">
        <p>マイページトップ</p>
      </button>
      <button
        @click="updateHeading('mod')"
        :class="{'js-nav__active': this.heading === 'mod'}"
        class="p-mypageHeding--nav__mod js-mod"
      >
        <img class="button-icon" src="@/assets/icon-edit-profile.png" alt="">
        <p>お客様情報の確認・編集</p>
      </button>
      <button
        @click="updateHeading('pass')"
        :class="{'js-nav__active': this.heading === 'pass'}"
        class="p-mypageHeding--nav__pass js-pass"
      >
        <img class="button-icon" src="@/assets/icon-change-password.png" alt="">
        <p>パスワードの変更 </p>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MypageHeading',
  props: ['heading'],
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    };
  },
  methods: {
    updateHeading(val) {
      if (val !== this.heading) {
        this.$emit('updated', val);
      }
    },
  },
};
</script>

<style scoped lang='scss'>
#my-page-header {
  padding: 20px 0px;

  #my-page-image-wrapper {
    flex-direction: row;
    margin: 0;
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
    padding-left: 6px;

    #my-page-icon {
      margin-right: 8px;
      height: 23px;
      width: 23px;
    }

    h1 {
      font-size: 20px;
    }
  }

  #my-page-navigation-wrapper {
    padding: 0px;
    margin-top: 4px;
    display: flex;
    flex-direction: row;

    button {
      background-color: white;
      width: 306px;
      font-weight: bold;
      margin: 6px;
      border: 1px #CCCCCC solid;
      cursor: pointer;
      display: flex;
      text-align: left;
      justify-content: center;
      align-items: center;
      border-radius: 12px;
      font-size: 13px;
      text-align: left;
      padding: 8px;
      height: 52px;

      .button-icon {
        height: 32px;
        width: 32px;
        margin-right: 6px;
      }
    }
    p {
      font-size: 16px;
      line-height: 20px;
    }
    .js-top {
      width: 52px;
      .button-icon {
        margin-right: 0px;
      }
      p {
        display: none;
      }
    }
    .js-mod {
      flex: 1.1;
      p {
        display: none;
      }
    }
    .js-pass {
      flex: 1;
      p {
        display: none;
      }
    }
  }

  .js-nav__active {
    border: 1px solid #E83532 !important;
  }
}

@media (min-width: 400px) {
  .js-pass p {
    display: block !important;
  }
  .js-mod p {
    display: block !important;
  }
}

@media (min-width: 640px) {
  #my-page-header {
    padding: 40px 40px 20px 40px;

    #my-page-image-wrapper {
      padding-left: 0px;
      margin: auto;
      flex-direction: column;
      width: 30%;

      #my-page-icon {
        height: 84px;
        width: 84px;
        margin-right: 0px;
        margin-bottom: 10px;
      }
    }

    #my-page-navigation-wrapper {
      margin-top: 20px;
      padding: 12px;

      .js-top {
        width: 52px;
        flex: 1;
      }
      button {
        border-radius: 32px;
        font-size: 16px;
        height: 56px;
        padding: 12px 12px;
        text-align: center;

        .button-icon {
          height: 24px;
          width: 24px;
          margin-right: 6px;
        }
      }
      .js-top {
        p {
          display: block;
        }
        .button-icon {
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
